'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /* eslint-disable */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('../../redux/modules/auth');

var _booking = require('../../redux/modules/booking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.auth.user,
    loggingIn: state.auth.loggingIn,
    showPass: state.auth.showPass
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    login: _auth.login, freeUpDriver: _booking.freeUpDriver, showHidePassword: _auth.showHidePassword
  }, dispatch);
};

var Login = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (evt) {
      evt.preventDefault();
      var clientId = _this.refs.clientId.value;
      var passKey = _this.refs.passKey.value;
      _this.props.login(clientId, passKey).then(function (result) {
        if (!result.error) {
          _this.props.freeUpDriver();
        }
      });
    }, _this.showPass = function () {
      if (_this.props.showPass) {
        _this.props.showHidePassword(false);
      } else {
        _this.props.showHidePassword(true);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          loggingIn = _props.loggingIn,
          showPass = _props.showPass;

      var styles = require('./Login.scss');
      var submitText = loggingIn ? 'Loading...' : 'LogIn';
      var eye = showPass ? 'fa-eye-slash' : 'fa-eye';
      var type = showPass ? 'text' : 'password';
      return _react2.default.createElement(
        'div',
        { className: styles.loginPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        !user && _react2.default.createElement(
          'div',
          { className: styles.loginWrapper },
          _react2.default.createElement(
            'form',
            { className: 'login-form', onSubmit: this.handleSubmit },
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'clientId' },
                'Client ID'
              ),
              _react2.default.createElement('input', { id: 'clientId', type: 'text', ref: 'clientId', placeholder: 'Enter a Client Id', className: 'form-control' }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'passKey' },
                'Pass Key'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.passWrapper },
                _react2.default.createElement('input', { id: 'passKey', type: type, ref: 'passKey', placeholder: 'Enter a Pass Key', className: 'form-control', autoComplete: 'off' || 'nope' }),
                _react2.default.createElement('i', { className: 'fa ' + eye, onClick: this.showPass })
              )
            ),
            _react2.default.createElement(
              'button',
              { className: 'btn btn-gosend', onClick: this.handleSubmit, disabled: loggingIn },
              submitText
            )
          )
        )
      );
    }
  }]);
  return Login;
}(_react.Component), _class.propTypes = {
  user: _propTypes2.default.object,
  loggingIn: _propTypes2.default.bool,
  login: _propTypes2.default.func,
  freeUpDriver: _propTypes2.default.func,
  showPass: _propTypes2.default.bool,
  showHidePassword: _propTypes2.default.func
}, _temp2);
exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(Login);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 870
// module chunks = 0